const getters = {
  attendanceTagItemsByProtocol(state) {
    return state.attendanceTagItemsByProtocol || {};
  },

  getAttendanceTagItemsByProtocol: (state) => (protocol) => {
    if (!protocol) return {};
    return (state.attendanceTagItemsByProtocol || {})[protocol] || {};
  },

  getAttendanceTagItemsByProtocolAndGroup: (state) => (protocol, groupId) => {
    if (!protocol || !groupId) return [];
    const byProtocol = (state.attendanceTagItemsByProtocol || {})[protocol];
    if (!byProtocol) return [];
    return byProtocol[groupId] || [];
  },

  getAttendanceTagItemsByProtocolFlattened: (state) => (protocol) => {
    if (!protocol) return [];
    const byProtocol = (state.attendanceTagItemsByProtocol || {})[protocol];
    if (!byProtocol) return [];
    return Object.keys(byProtocol).reduce((acc, groupId) => {
      const items = Array.isArray(byProtocol[groupId])
        ? byProtocol[groupId]
        : [];
      return acc.concat(items);
    }, []);
  },
};

export default getters;
